<div class="popover">
    <ng-container *ngIf="renderMethod === 'text'">
        <div [innerHTML]="content"></div>
    </ng-container>
    <ng-container *ngIf="renderMethod === 'template'">
        <ng-container *ngTemplateOutlet="content; context: context"></ng-container>
    </ng-container>
    <ng-container *ngIf="renderMethod === 'component'">
        <ng-container *ngComponentOutlet="content"></ng-container>
    </ng-container>
</div>